import { Grid } from '@adsk/alloy-react-box'
import React from 'react'
import { useTranslation } from '../../../../i18n'
import Theme from '@adsk/alloy-react-theme'

const HeaderComponent = (): JSX.Element => {
	const { t } = useTranslation()
	const { typography } = Theme
	return (
		<Grid gridAutoFlow="row">
			<p style={typography.heading1}>{t('CONFIRM_EDIT')}</p>
		</Grid>
	)
}
export default HeaderComponent
